var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecommend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49992 12.5417C2.37234 12.5417 1.45825 11.6276 1.45825 10.5C1.45825 9.37242 2.37234 8.45834 3.49992 8.45834C4.42462 8.45834 5.20574 9.07311 5.45689 9.9162L8.74992 9.91632V8.75L9.91659 8.74965V5.39198L8.60817 4.08297H5.24992V5.25002H1.74992V1.75002H5.24992V2.91631H8.60817L10.4999 1.02515L12.9748 3.50002L11.0833 5.39081V8.74965L12.2499 8.75V12.25H8.74992V11.083L5.457 11.0835C5.20596 11.9268 4.42475 12.5417 3.49992 12.5417ZM3.49992 9.625C3.01667 9.625 2.62492 10.0168 2.62492 10.5C2.62492 10.9833 3.01667 11.375 3.49992 11.375C3.98317 11.375 4.37492 10.9833 4.37492 10.5C4.37492 10.0168 3.98317 9.625 3.49992 9.625ZM11.0833 9.91667H9.91659V11.0833H11.0833V9.91667ZM10.4999 2.67506L9.67497 3.50002L10.4999 4.32498L11.3249 3.50002L10.4999 2.67506ZM4.08325 2.91669H2.91659V4.08335H4.08325V2.91669Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommend);
export default __webpack_public_path__ + "static/media/recommend.d79e202b7b03f110f6b7617571dd38b7.svg";
export { ForwardRef as ReactComponent };